import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { errorToast, successToast } from "../Common/showtoast";
import ApiRequest, { baseurl } from "../Common/restservice";
import ImageWithFallback from "../Components/ImageWithFallback";
import banner from "../Assets/Images/homebanner.jpg";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { Rating } from "react-simple-star-rating";
import {
  BiBriefcase,
  BiCalendar,
  BiDirections,
  BiIdCard,
  BiMoney,
} from "react-icons/bi";
import { FaCity, FaFlag, FaLocationPin, FaMap, FaMapLocation, FaUsers } from "react-icons/fa6";
import moment from "moment";
import Slider from "react-slick";

const reportcomments = [
  "Illegal/fraudulent",
  "Spam",
  "Duplicate User",
  "Against company rules",
  "Others",
];

function CompanyDetail() {
  const navigate = useNavigate();
  const { memberid } = useParams();
  const location = useLocation();

  const [currentTab, setCurrentTab] = useState(1);
  const [freeLancers, setfreeLancers] = useState({ photos: [] });
  const [contactDetails, setcontactDetails] = useState({});
  const [showContact, setshowContact] = useState(false);
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState("");
  const [reportMessage, setReportMessage] = useState("");
  const [selectedReport, setSelectedReport] = useState("");
  const [comments, setComments] = useState([]);
  const [photos, setPhotos] = useState([]);

  const carouselsettings = {
    customPaging: function (i) {
      return (
        <img
          style={{
            width: 200,
            height: "auto",
            display: "block",
            margin: "0 auto",
          }}
          src={`${baseurl}/${photos[i].imageurl}`}
        />
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,    // Changed to 1 to show only 1 image at a time
    slidesToScroll: 1,  // Changed to 1 for single scroll
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("token")) {
      navigate("/login");
    } else {
      GetFreeLancers();
      GetPhotos();
      GetComments();
    }
  }, [memberid]);

  const GetPhotos = async () => {
    let res = await ApiRequest(
      "getPortfolioImages.asp",
      "POST",
      JSON.stringify({ memberid: memberid }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      setPhotos([]);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setPhotos(res.items);
  };

  const GetFreeLancers = async () => {
    let res = await ApiRequest(
      "profiledetail.asp",
      "POST",
      JSON.stringify({ profileid: memberid }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      } else if (res.message === "Please update your profile to access other profiles,") {
        return navigate("/profile?err=" + res.message);
      }
      errorToast(res.message);
      return;
    }
    res.photos = [];
    setfreeLancers(res);
  };

  const GetComments = async () => {
    let res = await ApiRequest(
      "getcomments.asp",
      "POST",
      JSON.stringify({ pageno: 1, memberid: memberid }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      setComments([]);
      return;
    }
    setComments(res.items);
  };

  const AddComments = async () => {
    if (!rating) {
      return errorToast("Select valid rating");
    }
    let res = await ApiRequest(
      "add_comments.asp",
      "POST",
      JSON.stringify({ commentfor: memberid, rating, message: comment }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      errorToast(res.message);
      return;
    }
    successToast(res.message);
    setRating(0);
    setComment("");
    GetComments();
    GetFreeLancers();
  };

  const ReportUser = async () => {
    if (!selectedReport) {
      return errorToast("Please select the issue");
    } else if (selectedReport === "Others" && !reportMessage) {
      return errorToast("Enter valid message");
    }
    let res = await ApiRequest(
      "report_user.asp",
      "POST",
      JSON.stringify({
        commentfor: memberid,
        message: selectedReport === "Others" ? reportMessage : selectedReport,
      }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      errorToast(res.message);
      return;
    }
    successToast(res.message);
    setSelectedReport("");
    setReportMessage("");
  };

  const GetContacts = async () => {
    let res = await ApiRequest(
      "getContact.asp",
      "POST",
      JSON.stringify({
        profileid: memberid,
      }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      errorToast(res.message);
      return;
    }
    successToast(res.message);
    setcontactDetails(res);
    setshowContact(true);
  };

  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Company</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Company
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sptb" data-select2-id="13">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8 col-md-12">
              <div className="card overflow-hidden">
                <div className="card-body h-100 boot-slider">
                  <div className="item-det mb-1">
                    <div className="text-dark">
                      <div className="d-flex w-100 align-items-center">
                        <h3>{freeLancers.companyname}</h3>
                        <label
                          className={` ms-2 badge badge-${freeLancers.GSTAPPROVE ? "primary" : "danger"
                            }`}
                        >
                          <i className="fa fa-shield text-white me-1" />
                          {freeLancers.GSTAPPROVE ? "Verified" : "Not Verified"}
                        </label>
                        <div className="d-flex col-lg-4">
                          <label className="ms-auto">Share : </label>
                          <div className="product-filter-icons text-center ms-2">
                            <WhatsappShareButton
                              className=" apss-single-icon"
                              url={window.location.href}
                            >
                              <WhatsappIcon size={32} className="facebook-bg" />
                            </WhatsappShareButton>
                            <FacebookShareButton
                              className=" apss-single-icon"
                              url={window.location.href}
                            >
                              <FacebookIcon size={32} className="facebook-bg" />
                            </FacebookShareButton>
                            <TwitterShareButton
                              className=" apss-single-icon"
                              url={window.location.href}
                            >
                              <TwitterIcon
                                size={32}
                                className="apss-icon-block"
                              />
                            </TwitterShareButton>
                            <PinterestShareButton
                              className=" apss-single-icon"
                              url={window.location.href}
                              media={window.location.href}
                            >
                              <PinterestIcon
                                size={32}
                                className="apss-icon-block"
                              />
                            </PinterestShareButton>
                            <LinkedinShareButton
                              className=" apss-single-icon"
                              url={window.location.href}
                            >
                              <LinkedinIcon
                                size={32}
                                className="apss-icon-block"
                              />
                            </LinkedinShareButton>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ul className="d-flex">
                      <li className="me-5">
                        <label className="icons">
                          <BiBriefcase className=" text-muted me-1" />
                          {freeLancers.industry}
                        </label>
                      </li>
                      <li className="me-5">
                        <label className="icons">
                          <FaUsers className=" text-muted me-1" />
                          <span className="text-uppercase">
                            {freeLancers.companysize}
                          </span>
                        </label>
                      </li>
                    </ul>
                    <ul className="d-flex">
                      <li className="me-5">
                        <label className="icons">
                          <FaMapLocation className=" text-muted me-1" />
                          {freeLancers.address}
                        </label>
                      </li>
                    </ul>
                    <ul className="d-flex">
                      <li className="me-5">
                        <label className={`badge badge-success`}>
                          <BiMoney className="me-1" />
                          {freeLancers.pricing}
                        </label>
                      </li>
                      <li className="me-5">
                        <label className={`badge badge-info`}>
                          <BiDirections className="me-1" />
                          <a
                            className=" text-white"
                            href={freeLancers.googlelink}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Get Directions
                          </a>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <div className="wideget-user-tab">
                    <div className="tab-menu-heading">
                      <div className="tabs-menu1">
                        <ul className="nav">
                          <li className="nav-item">
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentTab(1);
                              }}
                              className={currentTab === 1 ? "active" : ""}
                            >
                              Overview
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentTab(4);
                              }}
                              className={currentTab === 4 ? "active" : ""}
                            >
                              Product / Service & Specialization / Expertise
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentTab(3);
                              }}
                              className={currentTab === 3 ? "active" : ""}
                            >
                              Gallery
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentTab(6);
                              }}
                              className={currentTab === 6 ? "active" : ""}
                            >
                              Certifications & Awards
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentTab(2);
                              }}
                              className={currentTab === 2 ? "active" : ""}
                            >
                              Ratings & Reviews
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentTab(5);
                              }}
                              className={currentTab === 5 ? "active" : ""}
                            >
                              Testimonials
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {currentTab === 5 && (
                  <div className="card-body">
                    <h3 className="my-3">Testimonials:</h3>
                    <div className="mb-4">
                      <p>{freeLancers.csr || "-- Not Disclosed --"}</p>
                    </div>
                  </div>
                )}
                {currentTab === 6 && (
                  <div className="card-body">
                    <h3 className="my-3">Certifications</h3>
                    <div className="mb-4">
                      <p>{freeLancers.certifications || "-- Not Disclosed --"}</p>
                    </div>
                    <h3 className="my-3">Awards</h3>
                    <div className="mb-4">
                      <p>{freeLancers.awards || "-- Not Disclosed --"}</p>
                    </div>
                  </div>
                )}
                {currentTab === 1 && (
                  <div className="card-body">
                    <h3 className="my-3">Description</h3>
                    <div className="mb-4">
                      <p>
                        {freeLancers.companydescription || "-- Not Disclosed --"}
                      </p>
                    </div>
                    <h3 className="my-3">Mission</h3>
                    <div className="mb-4">
                      <p>{freeLancers.mission || "-- Not Disclosed --"}</p>
                    </div>
                    <h3 className="my-3">Vision</h3>
                    <div className="mb-4">
                      <p>{freeLancers.vision || "-- Not Disclosed --"}</p>
                    </div>
                    <h3 className="my-3">Core Values / Philosophy</h3>
                    <div className="mb-4">
                      <p>{freeLancers.philosophy || "-- Not Disclosed --"}</p>
                    </div>
                    <h4 className="mb-4">Specifications</h4>
                    <div className="row">
                      <div className="col-xl-6 col-md-12">
                        <ul className="list-unstyled widget-spec mb-0">
                          <li className="">
                            <i className="fa fa-user text-muted w-5"></i>
                            {freeLancers.fullname}
                          </li>
                          <li className="">
                            <i className="fa fa-calendar text-muted w-5"></i>
                            Member Since : {freeLancers.joiningdate}
                          </li>
                          <li className="">
                            <i className="fa fa-shield text-muted w-5"></i>
                            Verification:{" "}
                            {freeLancers.GSTAPPROVE ? "Verified" : "Not Verified"}
                          </li>
                          <li className="">
                            <i className="fa fa-briefcase text-muted w-5"></i>
                            Industry : {freeLancers.industry}
                          </li>
                          <li className="">
                            <i className="fa fa-users text-muted w-5"></i>
                            Company Size :{" "}
                            <span className="text-uppercase">
                              {freeLancers.companysize}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-xl-6 col-md-12">
                        <ul className="list-unstyled widget-spec mb-0">
                          <li className="">
                            <i className="fa fa-registered text-muted w-5"></i>
                            Reg No : {freeLancers.regno}
                          </li>
                          <li className="">
                            <i className="fa fa-sticky-note text-muted w-5"></i>
                            GST No : {freeLancers.taxid}
                          </li>
                          <li className="">
                            <i className="fa fa-calendar text-muted w-5"></i> Years in
                            Business : {freeLancers.yearsinbusiness}
                          </li>
                          <li className="">
                            <i className="fa fa-money text-muted w-5"></i>
                            Pricing Offered : {freeLancers.pricing}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                {currentTab === 2 && (
                  <div className="card-body p-0">
                    {comments.length <= 0 && (
                      <div
                        className="row  justify-content-center align-items-center text-center"
                        style={{ minHeight: 300 }}
                      >
                        <div className="col-lg-12">
                          <img
                            style={{ maxWidth: 100, marginBottom: 20 }}
                            src={require("../Assets/Images/cart.png")}
                            alt="No comments"
                          />
                          <h4>Be the first one to rate this.</h4>
                        </div>
                      </div>
                    )}
                    {comments.map((item) => {
                      return (
                        <div className="media p-5 border-top mt-0" key={item.id}>
                          <div className="d-flex me-3">
                            <a href="#" onClick={(e) => e.preventDefault()}>
                              <ImageWithFallback
                                className="media-object brround"
                                src={baseurl + item.profilepic}
                                alt="User Avatar"
                              />
                            </a>
                          </div>
                          <div className="media-body">
                            <h5 className="mt-0 mb-1 font-weight-semibold">
                              {item.fullname}
                              <span className="fs-14 ms-2">
                                {item.rating} <i className="fa fa-star text-yellow" />
                              </span>
                            </h5>
                            <small className="text-muted">
                              <span>
                                <i className="fa fa-calendar me-2" />
                                {moment(item.date).format("MMM DD")}
                              </span>
                              <span>
                                <i className="fa fa-clock-o me-2 ms-3" />
                                {moment(item.date).format("HH:mm a")}
                              </span>
                            </small>
                            <p className="font-13  mb-2 mt-2">{item.message}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {currentTab === 3 && (
                  <div className="card-body">
                    {photos.length <= 0 && (
                      <div
                        className="row  justify-content-center align-items-center text-center"
                        style={{ minHeight: 300 }}
                      >
                        <div className="col-lg-12">
                          <img
                            style={{ maxWidth: 100, marginBottom: 20 }}
                            src={require("../Assets/Images/cart.png")}
                            alt="No images"
                          />
                          <h4>No Images Updated.</h4>
                        </div>
                      </div>
                    )}
                    {photos.length > 0 && (
                      <div className="product-slider carousel-slide-1 mt-2 mb-5">
                        <Slider
                          className="carousel slide carousel-fade"
                          {...carouselsettings}
                        >
                          {photos.map((item, index) => {
                            return (
                              <div className="slider-item" key={index}>
                                <img
                                  style={{ height: "300px", width: "auto" }}
                                  src={baseurl + item.imageurl}
                                  alt={`Gallery Image ${index + 1}`}
                                />
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    )}
                  </div>
                )}
                {currentTab === 4 && (
                  <div className="card-body" style={{ minHeight: 300 }}>
                    <h3 className="mb-3">Product / Service</h3>
                    <div className="row">
                      {freeLancers.servicesoffered?.split(",").map((item, idx) => {
                        return (
                          <div className="col-xl-6 col-md-12" key={idx}>
                            <h4>
                              <i className="fa fa-check-circle text-success w-5"></i>
                              {item}
                            </h4>
                          </div>
                        );
                      })}
                    </div>
                    <h3 className="mt-5 mb-3">Specialization / Expertise</h3>
                    <div className="row">
                      {freeLancers.skills?.split(",").map((item, idx) => {
                        return (
                          <div className="col-xl-6 col-md-12" key={idx}>
                            <h4>
                              <i className="fa fa-check-circle text-success w-5"></i>
                              {item}
                            </h4>
                          </div>
                        );
                      })}
                    </div>
                    <h3 className="mt-5 mb-3">Industries Served</h3>
                    <div className="row">
                      {freeLancers.industriesserved?.split(",").map((item, idx) => {
                        return (
                          <div className="col-xl-6 col-md-12" key={idx}>
                            <h4>
                              <i className="fa fa-check-circle text-success w-5"></i>
                              {item}
                            </h4>
                          </div>
                        );
                      })}
                    </div>
                    <h3 className="mt-5 mb-3">Service Areas</h3>
                    <div className="row">
                      {freeLancers.serviceareas?.split(",").map((item, idx) => {
                        return (
                          <div className="col-xl-6 col-md-12" key={idx}>
                            <h4>
                              <i className="fa fa-check-circle text-success w-5"></i>
                              {item}
                            </h4>
                          </div>
                        );
                      })}
                    </div>
                    <h3 className="mt-5 mb-3">Tools Used</h3>
                    <div className="row">
                      {freeLancers.tools?.split(",").map((item, idx) => {
                        return (
                          <div className="col-xl-6 col-md-12" key={idx}>
                            <h4>
                              <i className="fa fa-check-circle text-success w-5"></i>
                              {item}
                            </h4>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">User Info</h3>
                </div>
                <div className="card-body item-user">
                  <div className="profile-pic mb-0  row">
                    <div className=" col-4">
                      <ImageWithFallback
                        className="brround avatar-xxl"
                        src={baseurl + freeLancers.profilepic}
                        alt="admin"
                      />
                    </div>
                    <div className="col-8 text-start">
                      <h4 className="mt-3 mb-1 font-weight-semibold">
                        {freeLancers.fullname}
                      </h4>
                      <h6 className="badge text-small fs-10 badge-primary">
                        {freeLancers.usertype === "freelancer" ||
                          freeLancers.usertype === "Freelance Marketer"
                          ? "Freelance Marketer"
                          : "Businesses"}
                      </h6>
                      <br />
                      <label className="text-muted">
                        Member Since {freeLancers.joiningdate}
                      </label>
                    </div>
                  </div>
                  <hr className="my-1" />
                  <div className="">
                    <label
                      className={`badge badge-${freeLancers.AADHARAPPROVE ? "primary" : "danger"
                        }`}
                    >
                      <i className="fa fa-shield text-white me-1" />
                      {freeLancers.AADHARAPPROVE ? "Verified" : "Not Verified"}
                    </label>
                    <label className="icons ms-2">
                      <BiCalendar className=" text-muted me-1" />
                      {freeLancers.yearsinbusiness || 0} years in the industry
                    </label>
                    <br />
                    <label className="icons text-capitalize">
                      <BiIdCard className=" text-muted me-1 " />
                      {freeLancers.legalstructure || "Not Disclosed"}
                    </label>
                    <br />
                    <label className="icons">
                      <FaCity className=" text-muted me-1" />
                      {freeLancers.city}
                      {freeLancers.region && <> , {freeLancers.region}</>}
                      {freeLancers.country && <> , {freeLancers.country}</>}
                      {freeLancers.pincode && <> , {freeLancers.pincode}</>}
                    </label>
                    <br />
                    <button className="badge badge-primary">
                      <i className="fa fa-star text-white me-1" />
                      {freeLancers.avg_star_rating}
                    </button>
                    <label className="icons">
                      <span className=" ms-1">
                        {freeLancers.avg_star_rating || 0} Ratings
                      </span>
                    </label>
                  </div>
                </div>
                {showContact && (
                  <div className="card-body item-user">
                    <h4 className="mb-4">Contact Info</h4>
                    <div>
                      <h6>
                        <span className="font-weight-semibold">
                          <i className="fa fa-user me-2 mb-2"></i>
                        </span>
                        <a href="#" className="text-body">
                          {contactDetails.contactpersonname}
                        </a>
                      </h6>
                      <h6>
                        <span className="font-weight-semibold">
                          <i className="fa fa-envelope me-2 mb-2"></i>
                        </span>
                        <a href={`mailto:${contactDetails.email}`} className="text-body">
                          {contactDetails.email}
                        </a>
                      </h6>
                      <h6>
                        <span className="font-weight-semibold">
                          <i className="fa fa-phone me-2  mb-2"></i>
                        </span>
                        <a href={`tel:${contactDetails.mobile}`} className="text-primary">
                          {contactDetails.mobile}
                        </a>
                      </h6>
                      <h6>
                        <span className="font-weight-semibold">
                          <i className="fa fa-phone me-2  mb-2"></i>
                        </span>
                        <a href={`tel:${contactDetails.alternatemobile}`} className="text-primary">
                          {contactDetails.alternatemobile}
                        </a>
                      </h6>
                      {freeLancers.website && (
                        <h6>
                          <span className="font-weight-semibold">
                            <i className="fa fa-link me-2 "></i>
                          </span>
                          <a
                            href={
                              freeLancers.website?.startsWith("http")
                                ? freeLancers.website
                                : `https://${freeLancers.website}`
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="text-primary"
                          >
                            {freeLancers.website}
                          </a>
                        </h6>
                      )}
                    </div>
                    <div className=" item-user-icons mt-4">
                      {freeLancers.facebookprofile && (
                        <a
                          href={
                            freeLancers.facebookprofile?.startsWith("http")
                              ? freeLancers.facebookprofile
                              : `https://${freeLancers.facebookprofile}`
                          }
                          target="_blank"
                          rel="noreferrer"
                          className="facebook-bg mt-0"
                        >
                          <i className="fa fa-facebook"></i>
                        </a>
                      )}
                      {freeLancers.instaprofile && (
                        <a
                          href={
                            freeLancers.instaprofile?.startsWith("http")
                              ? freeLancers.instaprofile
                              : `https://${freeLancers.instaprofile}`
                          }
                          target="_blank"
                          rel="noreferrer"
                          className="bg-pink  text-white"
                        >
                          <i className="fa fa-instagram"></i>
                        </a>
                      )}
                      {freeLancers.linkedinprofile && (
                        <a
                          href={
                            freeLancers.linkedinprofile?.startsWith("http")
                              ? freeLancers.linkedinprofile
                              : `https://${freeLancers.linkedinprofile}`
                          }
                          target="_blank"
                          rel="noreferrer"
                          className="bg-info text-white"
                        >
                          <i className="fa fa-linkedin"></i>
                        </a>
                      )}
                    </div>
                  </div>
                )}
                <div className="card-footer">
                  <div className="text-start">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        if (!showContact) GetContacts();
                        else setshowContact(false);
                      }}
                    >
                      <i className="fa fa-user"></i> Contact Me
                    </button>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Leave a Comment</h3>
                </div>
                <div className="card-body product-filter-desc">
                  <div className="product-tags clearfix">
                    <form
                      className="form"
                      name="contactForm"
                      onSubmit={(e) => {
                        e.preventDefault();
                        AddComments();
                      }}
                    >
                      <p>
                        Your email address will not be published. Required fields are marked.{" "}
                        <span className="text-danger">*</span>
                      </p>
                      <div className="form-group">
                        <label className="text-start" htmlFor="msg">
                          Rating :<span style={{ color: "red" }}>*</span>
                        </label>
                        <Rating
                          style={{ marginLeft: "10px" }}
                          initialValue={rating}
                          onClick={(number) => setRating(number)}
                        />
                        <label
                          className="text-start mt-5"
                          htmlFor="msg"
                          style={{ width: "100%" }}
                        >
                          Comment :
                          <small style={{ float: "right", marginLeft: "auto" }}>
                            {comment?.length || 0} / 500
                          </small>
                        </label>
                        <textarea
                          id="msg"
                          style={{ minHeight: 100, margin: 0 }}
                          name="comments"
                          className="form-control"
                          onChange={(e) => {
                            if (e.target.value.length <= 500) setComment(e.target.value);
                          }}
                          value={comment}
                          placeholder="Type Message"
                        ></textarea>
                      </div>
                      <button className="btn btn-primary" type="submit">
                        Post Comment
                      </button>
                    </form>
                  </div>
                </div>
              </div>
              {/* Report User code is commented out */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CompanyDetail;
